<div
  class="support-banner intercomTrigger group flex h-[12.4rem] w-full cursor-pointer items-center justify-center overflow-hidden rounded-[2rem] bg-[linear-gradient(348deg,#2E4E9F_11.95%,#232E66_97.31%)] custom-transition-bg before:bg-[linear-gradient(348deg,#3657AF_11.95%,#2A3778_97.31%)] lg:h-[8.6rem] lg:rounded-[1.6rem]"
>
  <div
    class="z-[1] flex h-full w-full flex-col items-start justify-between rounded-[2rem] border-[0.2rem] border-solid border-[rgba(86,122,212,0.12)] p-[2rem] custom-transition-all group-hover:border-[rgba(86,122,212,0.32)] lg:rounded-[1.6rem] lg:p-[1.6rem]"
  >
    <div class="flex w-full flex-col items-start space-y-[0.4rem]">
      <span
        i18n="@@main.support.title"
        class="text-[1.6rem] font-400 leading-[2.4rem] text-white lg:text-[1.3rem] lg:leading-[1.6rem]"
        >Поддержка</span
      >
      @if (!isLg()) {
        <div class="flex h-[2rem] items-center justify-center rounded-full bg-[#6DEA5D] px-[0.7rem]">
          <span i18n="@@main.support.working" class="text-[0.9rem] font-450 leading-[1.2rem] text-green-100"
            >Работаем 24 / 7</span
          >
        </div>
      }
    </div>
    @if (isLg()) {
      <button
        class="flex h-[3rem] w-[5rem] items-center justify-center rounded-[1rem] bg-[#A5C6FF] opacity-80 custom-transition-all group-hover:w-[5.6rem] group-hover:bg-[#C6DBFF] lg:h-[2.6rem] lg:w-[3.8rem] lg:rounded-[0.8rem]"
      >
        <i class="icon icon_arrow-right-alt text-[2.4rem] !text-dark-250 lg:text-[1.8rem]"></i>
      </button>
    }
  </div>
  <div class="support-shadow"></div>
  <div class="support-support"></div>
</div>
